import { Projeto } from "./Projeto"

export class Upload{
    id?: number
    projeto?: Projeto
    nome?: string
    caminhoArquivo?: string
    dtCadastro?: Date
  static projeto: any
}